"use client";

import { useEffect } from "react";

export default function ScrollAnimator() {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll(".animate-on-scroll"));
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            // optionally unobserve
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 },
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return null;
}
